export default "/images/the-times.svg?9298e916285f940b8a5d08b8fa30ef20";